
  function useMouse(title) {
    const { ref, onMounted, onUnmounted, watch } = Vue
    const x = ref(0)
    const y = ref(0)

    function update(event) {
      x.value = event.pageX
      y.value = event.pageY
    }

    watch([x, y], (newValue, oldValue) => console.log(title.value, x.value, y.value, newValue, oldValue))

    onMounted(() => window.addEventListener('mousemove', update))
    onUnmounted(() => window.removeEventListener('mousemove', update))

    return { x, y }
  }

  Vue.component('test-composite', {
    props: {
      title: { type: String, required: true }
    },
    template: '#test-composite',
    setup(props) {
      const { toRefs } = Vue
      const { title } = toRefs(props)
      title.value = `"${title.value}"`
      const { x, y } = useMouse(title)
      return { x, y, title }
    }
  })
